// CancelCaseModal.jsx
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const CancelCaseModal = ({
  show,
  handleClose,
  handleConfirm,
  caseNumber,
}) => {
  const [reason, setReason] = useState("");

  const onConfirm = () => {
    handleConfirm(reason);
    setReason(""); // Reset reason after confirming
  };

  return (
    <>
      <style>
        {`
          /* =========================================
             CANCEL CASE MODAL
             DESKTOP - ORIGINAL SIZE
          ========================================= */

          .cancel-case-responsive-modal .modal-dialog {
            max-width: 500px;
            margin-left: auto;
            margin-right: auto;
          }

          .cancel-case-responsive-modal .modal-content {
            width: 100%;
            max-width: 100%;
            overflow: hidden;
            box-sizing: border-box;
          }

          .cancel-case-responsive-modal .modal-title {
            white-space: normal;
            overflow-wrap: anywhere;
            word-break: normal;
          }

          .cancel-case-responsive-modal .modal-body {
            overflow-wrap: anywhere;
            word-break: normal;
          }

          .cancel-case-responsive-modal .modal-footer {
            flex-wrap: wrap;
          }

          /* =========================================
             TABLET
          ========================================= */

          @media (max-width: 768px) {

            .cancel-case-responsive-modal .modal-dialog {
              width: calc(100% - 24px);
              max-width: 500px;
              margin: 12px auto;
            }

            .cancel-case-responsive-modal .modal-title {
              font-size: 17px;
            }

            .cancel-case-responsive-modal .modal-body {
              font-size: 14px;
            }

            .cancel-case-responsive-modal .modal-footer button {
              font-size: 13px;
              padding: 7px 12px;
            }
          }

          /* =========================================
             SMALL MOBILE
          ========================================= */

          @media (max-width: 576px) {

            .cancel-case-responsive-modal .modal-dialog {
              width: calc(100% - 16px) !important;
              max-width: none !important;
              margin: 8px auto !important;
            }

            .cancel-case-responsive-modal .modal-content {
              width: 100% !important;
              max-width: 100% !important;
              border-radius: 6px !important;
              overflow: hidden !important;
            }

            .cancel-case-responsive-modal .modal-header {
              padding: 9px 11px !important;
            }

            .cancel-case-responsive-modal .modal-title {
              font-size: 14px !important;
              line-height: 1.25 !important;
              max-width: calc(100% - 30px) !important;
              overflow-wrap: anywhere !important;
              word-break: normal !important;
            }

            .cancel-case-responsive-modal .modal-body {
              padding: 11px !important;
              font-size: 12px !important;
              line-height: 1.3 !important;
              overflow-wrap: anywhere !important;
            }

            .cancel-case-responsive-modal .form-label {
              font-size: 12px !important;
              line-height: 1.3 !important;
              margin-bottom: 5px !important;
              display: block !important;
              overflow-wrap: anywhere !important;
            }

            .cancel-case-responsive-modal .form-control {
              font-size: 12px !important;
              padding: 6px 8px !important;
              line-height: 1.3 !important;
              width: 100% !important;
              max-width: 100% !important;
              box-sizing: border-box !important;
            }

            .cancel-case-responsive-modal .modal-footer {
              padding: 7px 9px !important;
              gap: 5px !important;
              flex-wrap: wrap !important;
            }

            .cancel-case-responsive-modal .modal-footer button {
              font-size: 11px !important;
              padding: 5px 9px !important;
              line-height: 1.25 !important;
              white-space: normal !important;
            }
          }

          /* =========================================
             VERY SMALL MOBILE
          ========================================= */

          @media (max-width: 400px) {

            .cancel-case-responsive-modal .modal-dialog {
              width: calc(100% - 10px) !important;
              max-width: none !important;
              margin: 5px auto !important;
            }

            .cancel-case-responsive-modal .modal-header {
              padding: 7px 9px !important;
            }

            .cancel-case-responsive-modal .modal-title {
              font-size: 13px !important;
              line-height: 1.2 !important;
              max-width: calc(100% - 28px) !important;
            }

            .cancel-case-responsive-modal .modal-body {
              padding: 9px !important;
              font-size: 11px !important;
            }

            .cancel-case-responsive-modal .form-label {
              font-size: 11px !important;
              line-height: 1.25 !important;
              margin-bottom: 4px !important;
            }

            .cancel-case-responsive-modal .form-control {
              font-size: 11px !important;
              padding: 5px 7px !important;
              line-height: 1.25 !important;
            }

            .cancel-case-responsive-modal .modal-footer {
              padding: 6px 7px !important;
              gap: 4px !important;
            }

            .cancel-case-responsive-modal .modal-footer button {
              font-size: 10px !important;
              padding: 5px 7px !important;
              line-height: 1.2 !important;
            }
          }

          /* =========================================
             EXTRA SMALL MOBILE
          ========================================= */

          @media (max-width: 320px) {

            .cancel-case-responsive-modal .modal-dialog {
              width: calc(100% - 6px) !important;
              margin: 3px auto !important;
            }

            .cancel-case-responsive-modal .modal-header {
              padding: 6px 8px !important;
            }

            .cancel-case-responsive-modal .modal-title {
              font-size: 12px !important;
              max-width: calc(100% - 25px) !important;
            }

            .cancel-case-responsive-modal .modal-body {
              padding: 8px !important;
              font-size: 10px !important;
            }

            .cancel-case-responsive-modal .form-label {
              font-size: 10px !important;
            }

            .cancel-case-responsive-modal .form-control {
              font-size: 10px !important;
              padding: 4px 6px !important;
            }

            .cancel-case-responsive-modal .modal-footer {
              padding: 5px 6px !important;
            }

            .cancel-case-responsive-modal .modal-footer button {
              font-size: 9px !important;
              padding: 4px 6px !important;
            }
          }

          /* =========================================
             PREVENT CONTENT FROM GOING OUTSIDE
          ========================================= */

          .cancel-case-responsive-modal,
          .cancel-case-responsive-modal * {
            box-sizing: border-box;
          }
        `}
      </style>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="cancel-case-responsive-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Cancel Case #{caseNumber}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group controlId="cancellationReason">
              <Form.Label>
                Reason for Cancellation (Optional)
              </Form.Label>

              <Form.Control
                as="textarea"
                rows={3}
                value={reason}
                onChange={(e) =>
                  setReason(e.target.value)
                }
                placeholder="Enter reason for cancellation..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
          >
            Close
          </Button>

          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={caseNumber === undefined}
          >
            Confirm Cancellation
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CancelCaseModal;